import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import { ReactComponent as ScanBoxIcon } from "assets/img/wms/scanBox.svg";
import CustomButton from "../../../../../components/CustomButton";
import {Grid} from "@mui/material";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";
import React, {useContext, useEffect, useState} from "react";
import {BarCodeScannerContext} from "../../../../../contexts/barCodeScannerContext";
import {packingStepNames} from "../PackingOrderList/packingSteps";
import {
    getWMSContainers,
    getWMSContainerWithCodeBar
} from "../../../../../api/wms/wmsContainers/wmsContainers";
import {assignShipmentToContainer} from "../../../../../api/wms/shipment/shipment";
import {WmsContainerType} from "../../../../../utils/WMSContainerType";
import Toast from "../../../../../components/WMS/Toast";
import ErrorIcon from "../../../../../assets/img/error.svg";
import WMSCarrierIcon from "../../../../../components/WMS/WMSCarrierIcon";
import {WMSContext} from "../../../context/WMSContext";
import doesContainerMatchToShippingMethod from "../../../../../utils/WMSContainerToShippingMethodMatch";
import DropNotAllowedToast from "../../../../../components/WMS/DropNotAllowedToast";

ScanShippingZoneOrTrolleyModal.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleManualSelection: PropTypes.func.isRequired,
    handleSlipPrint: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    packingStep: PropTypes.object.isRequired,
    handleOffChartShipment: PropTypes.func.isRequired,
    finishPacking: PropTypes.func.isRequired,
    handleShipmentWaitForDrop: PropTypes.func.isRequired
};

function ScanShippingZoneOrTrolleyModal({open, handleClose, handleManualSelection, handleSlipPrint, isLoading, packingStep, handleOffChartShipment, handleShipmentWaitForDrop, finishPacking, isCC=false}) {
    const {scannedString, setEnableScan} = useContext(BarCodeScannerContext)
    const {currentOrganization} = useContext(WMSContext)

    const [ccError, setCcError] = useState(false)
    const [scanError, setScanError] = useState(false)
    const [openDropNotAllowedToast, setOpenDropNotAllowedToast] = useState(false)

    const handleFinishPacking = (response, shipment) => {
        assignShipmentToContainer(response.codebar, shipment.shipmentId).then(() => {
            finishPacking()
        })
    }

    const handleScanError = () => {
        setScanError(true)
        setEnableScan(true)
    }

    useEffect(() => {
        if (scannedString && scannedString.length > 0 && packingStep.stepName === packingStepNames.DROP_SHIPMENT) {
            setEnableScan(false)
            getWMSContainerWithCodeBar(scannedString).then((response) => {
                let shipment = packingStep.selectedShipment

                if (true === currentOrganization.containerToShippingMethodMatch && !doesContainerMatchToShippingMethod(response, shipment.shippingMethod)) {
                    setEnableScan(true)
                    setOpenDropNotAllowedToast(true)
                    return;
                }

                if (WmsContainerType.TROLLEY === response.type) {
                    handleFinishPacking(response, shipment)
                    return;
                }

                if (isCC) {
                    if (
                        (shipment.isCCInternalWMSShip && WmsContainerType.TIPPER === response.type) ||
                        (!shipment.isCCInternalWMSShip && WmsContainerType.CC === response.type)
                    ) {
                        handleFinishPacking(response, shipment)
                        return;
                    }

                    setCcError(true)
                } else {
                    if (WmsContainerType.TIPPER === response.type) {
                        handleFinishPacking(response, shipment)
                        return
                    }

                    if (WmsContainerType.HIVE === response.type || WmsContainerType.SHELF === response.type) {
                        handleOffChartShipment(response)
                        return
                    }
                }

                handleScanError()
            }).catch(() => {
                handleScanError()
            })
        }
    }, [scannedString]);

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<FormattedMessage id={"wms.packing.modal.scanDropZone.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.scanDropZone.subtitle"}/>}
            icon={<ScanBoxIcon/>}
            strictOnclose
            isMobile
        >
            {openDropNotAllowedToast && (
                <DropNotAllowedToast
                    open={openDropNotAllowedToast}
                    handleClose={() => setOpenDropNotAllowedToast(false)}
                    shippingMethodName={packingStep.selectedShipment.shippingMethod.shopName}
                />
            )}

            {ccError && (
                <Toast
                    open={ccError}
                    handleClose={() => setCcError(false)}
                    title={<FormattedMessage id={"wms.packing.scanShippingZoneOrTrolleyModal.ccErrorToast.title"}/> }
                    subtitle={<FormattedMessage id={"wms.packing.scanShippingZoneOrTrolleyModal.ccErrorToast.subtitle"}/> }
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                />
            )}

            {scanError && (
                <Toast
                    open={scanError}
                    handleClose={() => setScanError(false)}
                    title={<FormattedMessage id={"wms.packing.scanShippingZoneOrTrolleyModal.scanError.title"}/> }
                    subtitle={<FormattedMessage id={"wms.packing.scanShippingZoneOrTrolleyModal.scanError.subtitle"}/> }
                    icon={<img style={{height: '20px', width: '20px'}} src={ErrorIcon} alt={"validated-icon"}/>}
                />
            )}
            <Grid container direction={"column"} justifyContent={"space-between"} gap={"16px"}>
                <TextEmphasisBloc
                    isBold
                    floatLeft
                    leftPart={
                        <Grid container flexWrap={"nowrap"}>
                            {packingStep.selectedShipment.shippingMethod.carrierIcon && (
                                <Grid item sx={{margin: "auto 8px"}}>
                                    <WMSCarrierIcon
                                        iconName={packingStep.selectedShipment.shippingMethod.carrierIcon}
                                        altName={packingStep.selectedShipment.shippingMethod.carrierIcon}
                                    />
                                </Grid>
                            )}
                            <Grid
                                container
                                direction={"column"}
                                alignItems={"center"}
                                sx={{marginX: "auto"}}
                            >
                                <span>{packingStep.selectedShipment.shippingMethod.shopName}</span>
                                <span>{packingStep.selectedShipment.shippingMethod.name}</span>
                            </Grid>
                        </Grid>
                    }
                />
                <Grid container direction={"column"} gap={"16px"} style={{marginBottom: "16px"}}>
                    <CustomButton onClick={handleShipmentWaitForDrop} fullWidth>
                        <FormattedMessage id={"wms.packing.modal.scanDropZone.buttonLabel.shipmentDropWait"}/>
                    </CustomButton>

                    <CustomButton onClick={handleManualSelection} fullWidth color={"default"}>
                        <FormattedMessage id={"wms.packing.modal.scanDropZone.buttonLabel"}/>
                    </CustomButton>
                </Grid>

                <CustomButton onClick={() => handleSlipPrint(true)} fullWidth color={"default"}>
                    {!isLoading ?
                        <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton"}/> :
                        <FormattedMessage id={"wms.packing.modal.scanDropZone.printButton.isLoading"}/>
                    }

                </CustomButton>
            </Grid>

        </Popup>
    );
}

export default ScanShippingZoneOrTrolleyModal;
